// extracted by mini-css-extract-plugin
module.exports = {"body":"TypeDistributionPanel_body__EovLi","noData":"TypeDistributionPanel_noData__3gSmj"};